<template>
  <div class="flex flex-col flex-1 gap-2 px-4">
    <div class="font-bold mt-4">
      <template v-if="!isOrigin">
        {{ t(`painting.layout.img`) }}
      </template>
    </div>
    <div
      class="flex justify-center items-center"
      @click="showImgUploadPopup = true"
    >
      <div
        :class="[
          'rounded-lg overflow-hidden flex justify-center items-center border  text-base-content/50 bg-base-200',
          reqData.env.media ? '' : 'w-full min-h-[10rem]',
        ]"
      >
        <BaseImg
          v-if="reqData.env.media"
          class="max-w-full"
          :media="{ url: reqData.env.media.url! }"
          fit="cover"
        />
        <div v-else>
          <button class="btn btn-xs rounded px-4">
            <!-- 编辑 -->
            {{ t(`painting.${isOrigin ? "origin" : "layout"}.upload`) }}
            <!-- {{ t(`painting.layout.upload`) }} -->
          </button>
        </div>
      </div>
    </div>
    <template v-if="reqData.env.media">
      <div class="text-center">
        <button
          class="btn btn-primary btn-xs rounded px-4"
          @click="
            (reqData.env.media = undefined), (reqData.env.mediaId = undefined)
          "
        >
          {{ $t("Buttons.deleteReferenceImage") }}
        </button>
      </div>
      <div class="font-bold mt-4">
        {{ t(`painting.layout.weight`) }}
      </div>
      <div class="flex justify-between w-full items-center gap-4">
        <div>0.1</div>
        <VanSlider
          v-model="reqData.env.weight"
          :min="0.1"
          :max="1"
          size="sm"
          :step="0.1"
        >
          <template #button>
            <button class="btn btn-circle btn-xs">
              {{ reqData.env.weight }}
            </button>
          </template>
        </VanSlider>
        <div>1</div>
      </div>
    </template>
  </div>

  <media-select-popup
    @on-media-selected="onMediaSelected"
    enable-use-avatar
    media-type="img"
    :multiple="false"
    v-model:show="showImgUploadPopup"
    :upload-type="7"
    :max-count="1"
    :enable-crop="true"
    :enable-go-image-gen="false"
    :cropAspectRatio="cropAspectRatio"
    showRatioSelect
    @update:crop-aspect-ratio="onCropAspectRatioChange"
    replace
  />
</template>

<script setup lang="ts">
import { useGlobalUser } from "@/stores/globalUser";
import { MediaUploadFileItem } from "@/types/component";
import { PropType } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
  isOrigin: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["uploadNsfwImage"]);
const { t } = useI18n();
const showImgUploadPopup = ref(false);

const onMediaSelected = (list: MediaUploadFileItem[]) => {
  if (list.length > 0) {
    if (list[0].isNsfw) {
      emit("uploadNsfwImage", {
        id: list[0].mediaId,
        isNsfw: list[0].isNsfw,
        url: list[0].url,
      });
    } else {
      // @ts-ignore
      props.reqData.env.media = list[0];
      props.reqData.env.mediaId = list[0].mediaId;
      props.reqData.ratio = cropAspectRatio.value === 3 / 4 ? "3:4" : "16:9";
    }
  }
};

const cropAspectRatio = ref(3 / 4);
const onCropAspectRatioChange = (_ratio: string) => {
  const [w, h] = _ratio.split(":").map(Number);
  cropAspectRatio.value = w / h;
};
</script>
